import LegalPage from "@/pages/legal/page";

export default function TermsPage() {
  return <LegalPage defaultTab="terms" />;
}
